import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import configureStore from "./store";
import { setStore } from "./store/instance";
import "./i18n";

import App from "./components/App";

const main = document.querySelector("#main");
const initialState = (window && window.__INITIAL_STATE__) || {};
const store = configureStore(initialState);
setStore(store);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  main
);
